import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function BynderIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="12"
        viewBox="0 0 16 12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12.1858 1.40027e-06C13.6825 0.00244731 15.04 0.874241 15.6585 2.23028C16.277 3.58631 16.0426 5.17678 15.0589 6.29912L10.3062 11.033C9.702 11.6519 8.8715 12.0008 8.00431 12C7.13297 11.9998 6.29844 11.6504 5.68922 11.0306L5.35943 10.7061L6.97051 9.10324L7.31351 9.4421C7.49057 9.63106 7.73804 9.73914 7.9977 9.74092C8.25866 9.74372 8.50955 9.64081 8.69271 9.45585L13.2508 4.92096C13.5016 4.64315 13.6388 4.28197 13.6353 3.90856C13.6389 3.50078 13.4788 3.10842 13.1904 2.81867C12.9019 2.52891 12.5092 2.36576 12.0993 2.36546C11.7223 2.36084 11.3576 2.4981 11.0781 2.74974L4.21991 9.57358L0.937692 6.29434C0.332088 5.59883 -0.000872269 4.70923 1.71622e-06 3.78903C0.00576497 2.27911 0.909022 0.915661 2.30145 0.315042C3.69388 -0.285577 5.31158 -0.0095362 6.42327 1.01838L6.89001 1.48215L5.27113 3.09278C5.27113 3.09278 5.01283 2.82683 4.92152 2.74675C4.64303 2.49771 4.28078 2.36165 3.90634 2.36546C3.49699 2.36307 3.10359 2.52323 2.81335 2.81042C2.5231 3.09762 2.35998 3.48814 2.36015 3.89541C2.35527 4.27167 2.4927 4.63602 2.74519 4.91618L4.2085 6.37203L9.32044 1.2921C10.0433 0.470136 11.088 -0.000937312 12.1858 1.40027e-06Z" />
      </svg>
    </Icon>
  );
}
